






































































import Component from "vue-class-component";
import InsertionBroadcastDate from "./fields/BroadcastDate.vue";
import InsertionMedia from "./fields/Media.vue";
import InsertionDocuments from "./fields/Documents.vue";
import InsertionStatus from "./fields/Status.vue";
import InsertionCampaign from "./fields/Campaign.vue";
import InsertionSupplier from "./fields/Supplier.vue";
import InsertionLabel from "./fields/Label.vue";
import InsertionSupport from "./fields/Support.vue";
import InsertionQuotationNumber from "./fields/QuotationNumber.vue";
import InsertionServiceFeeQuotation from "./fields/ServiceFeeQuotation.vue";
import InsertionAdSpaceQuotation from "./fields/AdSpaceQuotation.vue";
import InsertionTotalQuotation from "./fields/TotalQuotation.vue";
import InsertionInvoicingPeriod from "./fields/InvoicingPeriod.vue";
import InsertionRequest from "./fields/Request.vue";
import InsertionPaymentPeriod from "./fields/PaymentPeriod.vue";
import StandardList from "front-component/components/List.vue";
import Orders from "@/components/miscellaneous/Orders.vue";
import Http from "front-component/Http";
import EventBus from "front-component/EventBus";
import InsertionRepository from "@/repositories/insertion/InsertionRepository";
import {Prop, Watch} from "vue-property-decorator";
import _ from "lodash";

const components = {
    InsertionDocuments,
    InsertionBroadcastDate,
    InsertionMedia,
    InsertionStatus,
    InsertionCampaign,
    InsertionSupplier,
    InsertionLabel,
    InsertionSupport,
    InsertionQuotationNumber,
    InsertionServiceFeeQuotation,
    InsertionAdSpaceQuotation,
    InsertionTotalQuotation,
    InsertionInvoicingPeriod,
    InsertionPaymentPeriod,
    InsertionRequest,
    Orders,
};

@Component({ components })
export default class List extends StandardList {
    protected route: string = "get_insertion";
    protected fields: string[] = [];

    @Prop( { default: "" }) public hiddenComponent !: string[];
    @Prop( { default: 50}) public limitPerPage !: number;

    public activeComponent(component: string) {
        return !_.includes(this.hiddenComponent, component);
    }

    public created(): void {
        this.fields = Http.computeStandardFields(components, "insertion");
    }

    protected link(): string {
        return InsertionRepository.getSearchUrl();
    }
    @Watch("limitPerPage") public loadExport() {
        this.page = 1;
        this.hasNextPage = true;
        this.elements = [];
        this.loadUsingApi();
    }

    private launchVisualization(uuid: string | null) {
        this.$emit("show-insertion", { uuid });
    }
}
